module.exports = __webpack_public_path__ + "fonts/fa-regular-400.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-regular-400.eot
// module id = 12
// module chunks = 0